import { jsx as _jsx } from "react/jsx-runtime";
export var WhatsappIcon = function WhatsappIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    className: className,
    children: /*#__PURE__*/_jsx("path", {
      fill: "#1C1C33",
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.96 9.96 0 0 1-5.016-1.348l-4.948 1.382 1.426-4.828-.006-.007-.033-.055A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2m0 2a8 8 0 0 0-6.895 12.06l.569.717-.696 2.36 2.32-.649.378.243A8 8 0 1 0 12 4M9.455 7.172c.289 0 .497.175.654.552.066.156.68 1.639.716 1.71a.68.68 0 0 1 .02.641l-.033.066a1.6 1.6 0 0 1-.237.376l-.117.14c-.083.1-.17.203-.249.281a.5.5 0 0 0-.085.101s.001.018.024.058c.163.275 1.35 1.91 2.915 2.589.068.03.293.123.306.123.015 0 .039-.025.057-.045.136-.154.577-.67.722-.886q.196-.29.492-.291c.12 0 .234.037.34.075.259.094 1.716.811 1.755.83.191.092.343.164.43.308.128.211.077.795-.115 1.329-.244.677-1.316 1.233-1.804 1.276l-.071.007c-.113.011-.24.024-.4.024-.38 0-1.05-.065-2.462-.63-1.466-.585-2.913-1.842-4.074-3.536l-.04-.061c-.304-.4-1.01-1.45-1.01-2.562 0-1.235.591-1.938.94-2.159.33-.208 1.077-.305 1.214-.311.112-.005.085-.005.112-.005"
    })
  });
};